import React, { useState } from "react";
import Wrapper from "../Layout/Wrapper";
import Button from "../Button";
import StarBackground from "../../assets/star-background.png";
import styled, { CSSProperties } from "styled-components";
import Modal from "antd/lib/modal/Modal";
import ImageUploading, { ImageListType } from "react-images-uploading";

const BannerWrapper = styled.div`
  background-color: linear-gradient(180deg, #235390 0%, #59a2ff 156.47%);
  height: 136px;
  width: 100%;
  color: white;
  display: flex;
  align-items: center;
  hgroup {
    justify-self: left;
    h1,
    h2 {
      margin: 0;
      color: white;
    }
    h2 {
      font-size: 18px;
    }
  }

  img {
    justify-self: left;
    width: 80px;
    height: 80px;
    border-radius: 80px;
    margin-right: 24px;
    border: 4px solid white;
    cursor: pointer;
  }

  .action {
    margin-left: auto;
    justify-self: right;
  }
`;

const getImageName = (fileType: string) => {
  if (fileType.includes("jpeg") || fileType.includes("jpg")) {
    return "profile.jpg";
  }
  if (fileType.includes("png")) {
    return "profile.png";
  }
  return "profile.png";
};

const dataURItoBlob = (dataURI?: string) => {
  if (!dataURI) {
    return undefined;
  }
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(",")[1]);

  // separate out the mime component
  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  var ia = new Uint8Array(ab);

  // set the bytes of the buffer to the correct values
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  var blob = new Blob([ab], { type: mimeString });
  return blob;
};

type SubHeaderProps = {
  title: string;
  subtitle: string;
  buttonText?: string;
  onClick?: () => void;
  imageUrl?: string;
  disabled?: boolean;
  onImageChange?: (
    imageName: string,
    imageBlob: Blob,
    imageDataURI: string
  ) => void;
  style?: CSSProperties;
};

const SubHeader = ({
  title,
  subtitle,
  buttonText,
  onClick,
  imageUrl,
  onImageChange,
  disabled,
  style = {},
}: SubHeaderProps) => {
  const [images, setImages] = useState<ImageListType>([]);
  const [showingImageChangeModal, showImageChangeModal] = useState(false);

  const onChange = (imageList: ImageListType) => {
    // data for submit
    setImages(imageList);
  };

  return (
    <BannerWrapper
      className="sub-header"
      style={{
        backgroundImage: `url('${StarBackground}')`,
        ...style,
      }}
    >
      <Wrapper style={{ alignItems: "center" }}>
        {imageUrl && (
          <img
            src={imageUrl}
            alt="Profile"
            onClick={() => showImageChangeModal(true)}
          />
        )}
        <hgroup>
          <h1>{title}</h1>
          <h2>{subtitle}</h2>
        </hgroup>
        {buttonText && onClick && (
          <div className="action">
            <Button onClick={onClick} disabled={disabled}>
              {buttonText}
            </Button>
          </div>
        )}
      </Wrapper>

      <Modal
        visible={showingImageChangeModal}
        onCancel={() => showImageChangeModal(false)}
        footer={null}
      >
        <ImageUploading
          multiple
          value={images}
          onChange={onChange}
          maxNumber={1}
          dataURLKey="data_url"
          maxFileSize={1000000} // 1MB as Bytes
        >
          {({
            imageList,
            onImageUpload,
            onImageUpdate,
            onImageRemove,
            isDragging,
            dragProps,
          }) => (
            <div className="upload__image-wrapper">
              {images.length <= 0 && (
                <Button
                  small
                  style={isDragging ? { color: "red" } : undefined}
                  onClick={onImageUpload}
                  {...dragProps}
                >
                  Click or Drop here to upload
                </Button>
              )}
              {imageList.map((image, index) => (
                <div key={index} className="image-item">
                  <img src={image["data_url"]} alt="" width="100" />
                  <div className="image-item__btn-wrapper">
                    <Button small onClick={() => onImageUpdate(index)}>
                      Update
                    </Button>
                    <Button small onClick={() => onImageRemove(index)}>
                      Remove
                    </Button>
                  </div>
                </div>
              ))}
              {images.length > 0 && (
                <div style={{ marginTop: 16 }}>
                  <Button
                    small
                    onClick={() => {
                      const { data_url, file } = images[0];
                      const imageBlob = dataURItoBlob(data_url);
                      if (onImageChange && file && data_url && imageBlob) {
                        onImageChange(
                          getImageName(file?.type),
                          imageBlob,
                          data_url
                        );
                        setImages([]);
                      }
                      showImageChangeModal(false);
                    }}
                  >
                    Upload
                  </Button>
                </div>
              )}
            </div>
          )}
        </ImageUploading>
      </Modal>
    </BannerWrapper>
  );
};

export default SubHeader;
